export const layerStyles = {
  page: {
    my: -8,
    py: 8,
    bg: 'gray.100',
    _dark: { bg: 'gray.800' },
  },
}
